import '../config/sentry';
import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import { CssBaseline } from '@mui/material';
import { Suspense, lazy } from 'react';
import { theme } from '../config/theme';
import { StrictMode } from 'react';
import SvceLayout from '../layouts/SvceLayout';
import AppSkeleton from '../components/AppSkeleton';
import axios from 'axios';
import ReactGA from 'react-ga4';
import './application.css'

ReactGA.initialize('G-S5VW766YYM', {
  nonce: document.querySelector('meta[name="csp-nonce"]')?.content,
});

const pages = import.meta.glob('../pages/**/*.jsx');
const pageCache = {};

createInertiaApp({
  resolve: (name) => {
    if (!pageCache[name]) {
      const LazyPage = lazy(() =>
        pages[`../pages/${name}/index.jsx`]().then(module => {
          module.default.layout = module.default.layout || SvceLayout;
          LazyPage.layout = module.default.layout;
          return module;
        })
      );
      LazyPage.layout = SvceLayout;
      pageCache[name] = LazyPage;
    }
    return pageCache[name];
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <ThemeProvider theme={theme}>
        <StrictMode>
          <CssBaseline />
          <Suspense fallback={<AppSkeleton />}>
            <App {...props} />
          </Suspense>
        </StrictMode>
      </ThemeProvider>,
    );
  },
});

const csrfToken = document.querySelector('meta[name=csrf-token]')?.content;
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
}

